import { Flex, Image, Link, Text } from "@chakra-ui/react";
import Slider from "react-slick";

import { useStoriesContents } from "@/hooks/Contents";
import { useIsomorphicLayoutEffect } from "@/hooks/Custom";
import { StoriesContentsArray } from "@/types";
import { useState } from "react";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

type Promo = {
  src: string;
  alt: string;
  url: string;
};

export function CarouselPromoMobile() {
  const [ListPromo, setListPromo] = useState<StoriesContentsArray>(null);
  const [PromoData, PromoError, PromoLoading] = useStoriesContents();

  useIsomorphicLayoutEffect(() => {
    if (PromoData) {
      setListPromo(PromoData?.[0]?.contentsArray);
    }
  }, [PromoData]);

  const settings = {
    arrows: false,
    dots: true,
    slidesToShow: 4,
    autoplay: true,
    infinite: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 950,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },

      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };
  const renderSlides = () =>
    ListPromo.map((slide, index) => (
      <Flex key={index}>
        <Flex justify="center">
          <Link href={slide.Url} transition=".5s">
            <Image
              w="full"
              h="auto"
              objectFit={"contain"}
              borderRadius={"5px"}
              src={slide.Image}
              alt={slide.Alt}
            />
          </Link>
        </Flex>
      </Flex>
    ));

  return (
    <>
      <Flex justify="center" w="full" direction="column" pb={"10px"}>
        <Slider {...settings}>{ListPromo ? renderSlides() : null}</Slider>
      </Flex>
    </>
  );
}
